module.exports = {"attributes":{"width":"40","height":"40","viewBox":"0 0 40 40","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M20,40 C8.954305,40 0,31.045695 0,20 C0,8.954305 8.954305,0 20,0 C31.045695,0 40,8.954305 40,20 C40,31.045695 31.045695,40 20,40 Z M20,18.7486363 L12.681364,11.4300003 L11.4300003,12.681364 L18.7486363,20 L11.4300003,27.318636 L12.681364,28.5699997 L20,21.2513637 L27.318636,28.5699997 L28.5699997,27.318636 L21.2513637,20 L28.5699997,12.681364 L27.318636,11.4300003 L20,18.7486363 Z\" fill=\"currentColor\" fill-rule=\"nonzero\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
